import * as handler from './handler';
import { PATH_BROKERS, PATH_USER_DETAILS } from './path';

const getBrokers = () =>
  handler.get(PATH_BROKERS).then((res) => {
    return res;
  });

const getActiveBrokers = (userId) =>
  handler.get(`${PATH_USER_DETAILS}protected-routes/${userId}/brokers`).then((res) => {
    return res;
  });

const getProperties = (brokerId, userId) =>
  handler.get(`${PATH_USER_DETAILS}protected-routes/${userId}/brokers/${brokerId}/properties`).then((res) => {
    return res;
  });

const connectPortfolio = (brokerId, payload, userId) =>
  handler.post(`${PATH_USER_DETAILS}protected-routes/${userId}/brokers/${brokerId}`, payload).then((res) => {
    return res;
  });

const getConnectedBrokers = (brokerId, userId) =>
  handler.get(`${PATH_USER_DETAILS}protected-routes/${userId}/brokers/${brokerId}`).then((res) => {
    return res;
  });

export default { getBrokers, getActiveBrokers, getProperties, connectPortfolio, getConnectedBrokers };
